import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.Box,
  title: 'Box',
  category: ComponentCategory.Layout,
  droppable: true,
};
